export const API_HOST: string = import.meta.env.VITE_API_HOST;
